export default function () {
  return {
    account: null,
    accounts: null,
    selectedAccount: null,
    transactions: null,
    filterParams: null,
  };
}
